// extracted by mini-css-extract-plugin
export default {"btn":"FileSelect_btn__uWXfu"};